import React from "react";
import { Location } from "../Location";
import { BookingEdit } from "@bookings/BookingEdit/BookingEdit";

interface Params {
  bookingId: string;
}

export class BookingDuplicateLocation extends Location<Params> {
  constructor(bookingId: string) {
    super({ bookingId });
  }

  render() {
    return <BookingEdit duplicateFrom={this.params.bookingId} />;
  }

  toURI() {
    return `/bookings/${this.params.bookingId}/duplicate`;
  }
}
